import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    allCoins: [],
    allTradePairs: [],
    balanceCoins: [],
    totalBalances: [],
    detailBalances: [],
    currentBalance: [],
    currentCoins: [],
    currentLock: [],
    currentLockTotal: 0,
    tradeFee: [],
    contractTransfer: [],
    contractTransferTotal: 0,
    contractUser: [],
    contractUserTotal: 0,
    pledgeUser: [],
    pledgeUserTotal: 0,
    tribeCheifProfit: [],
    tribeMemberProfit: [],
    tribeMemberProfitTotal: 0,
    userLoginCount: [],
    userRegisterCount: [],
    kycUserCount:[],
    depositWithdraw: [],
    withdrawFreeze: [],
    currentRank: [],
    txRecord: [],
    txRecordTotal: 0,
    iTxRecord: [],
    iTxRecordTotal: 0,
    statisticList: [],
    tableAble: false,
    totalStakingPosition: [],
    userStakingPosition: [],
    tradeVolumeData: [],
    tradeOrderData: [],
    tradeOrderTotal: 0,
    unFinishOrderData: [],
    listingApplyData: [],
    listingApplyTotal: 0,
    dwSummary: [],
    dwSummaryTotal: 0,
    returnList: [],
    pagination: {
      page: 1,
      size: 10
    },
    returnTotal: 0
  },
  mutations: {
    setTableAble(state, payload) {
      state.tableAble = payload;
    },
    setData(state, payload) {
      state[payload.key] = payload.value;
    },
    setKycUserCount(state,payload) {
      state.kycUserCount = payload;
    },
    setReturnList(state, payload) {
      state.returnList = payload
    },
    setPagination(state, payload) {
      state.pagination = payload
    },
    setReturnTotal(state, payload) {
      state.returnTotal = payload
    }
  },
  getters: {},
  actions: {
    getAllCoins({ commit }, query) {
      api.getAllCoins(query).then(({ data }) => {
        if(data) {
          commit('setTableAble', false);
          commit('setData', {
            key: 'allCoins',
            value: data
          });
          window.setTimeout(() => {
            commit('setTableAble', true);
          }, 1);
        }
      });
    },
    getBalanceBySnapshootTime({ commit }, query) {
      commit('setData', {
        key: 'balanceCoins',
        value: []
      });
      let coins = [];
      api.getBalanceBySnapshootTime(query).then(({ data }) => {
        if(data) {
          commit('setTableAble', false);
          commit('setData', {
            key: 'totalBalances',
            value: data
          })
          data.forEach((v, i, a) => {
            coins.push(v.coinType);
          });
          commit('setData', {
            key: 'balanceCoins',
            value: coins
          });
          window.setTimeout(() => {
            commit('setTableAble', true);
          }, 1);
        }
      });
    },
    getBalanceNow({ commit }, query) {
      api.getBalanceNow(query).then(({ data }) => {
        if(data) {
          commit('setTableAble', false);
          commit('setData', {
            key: 'detailBalances',
            value: data
          });
          window.setTimeout(() => {
            commit('setTableAble', true);
          }, 1);
        }
      });
    },
    getCurrentBalance({ commit }, query) {
      api.getCurrentBalance(query).then(({ data }) => {
        if(data) {
          commit('setTableAble', false);
          commit('setData', {
            key: 'currentBalance',
            value: data
          });
          let coins = [];
          data.forEach((v, i, a) => {
            coins.push(v.coinType);
          });
          commit('setData', {
            key: 'currentCoins',
            value: coins
          });
          window.setTimeout(() => {
            commit('setTableAble', true);
          }, 1);
        }
      });
    },
    getCurrentLock({ commit }, query) {
      api.getCurrentLock(query).then(({ data }) => {
        if(data) {
          commit('setTableAble', false);
          commit('setData', {
            key: 'currentLock',
            value: data.list || []
          });
          commit('setData', {
            key: 'currentLockTotal',
            value: data.totalCount
          });
          window.setTimeout(() => {
            commit('setTableAble', true);
          }, 1);
        }
      });
    },
    getTradeFeeTime({ commit }, query) {
      api.getTradeFeeTime(query).then(({ data }) => {
        if(data) {
          commit('setTableAble', false);
          commit('setData', {
            key: 'tradeFee',
            value: data
          });
          window.setTimeout(() => {
            commit('setTableAble', true);
          }, 1);
        }
      });
    },
    getContractTransfer({ commit }, query) {
      api.getContractTransfer(query).then(({ data }) => {
        if(data) {
          commit('setTableAble', false);
          commit('setData', {
            key: 'contractTransfer',
            value: data.list
          });
          commit('setData', {
            key: 'contractTransferTotal',
            value: data.totalCount
          });
          window.setTimeout(() => {
            commit('setTableAble', true);
          }, 1);
        }
      });
    },
    getContractUser({ commit }, query) {
      api.getContractUser(query).then(({ data }) => {
        if(data) {
          commit('setTableAble', false);
          commit('setData', {
            key: 'contractUser',
            value: data.list
          });
          commit('setData', {
            key: 'contractUserTotal',
            value: data.totalCount
          });
          window.setTimeout(() => {
            commit('setTableAble', true);
          }, 1);
        }
      });
    },
    getPledgeUser({ commit }, query) {
      api.getPledgeUser(query).then(({ data }) => {
        if(data) {
          commit('setTableAble', false);
          commit('setData', {
            key: 'pledgeUser',
            value: data.list
          });
          commit('setData', {
            key: 'pledgeUserTotal',
            value: data.totalCount
          });
          window.setTimeout(() => {
            commit('setTableAble', true);
          }, 1);
        }
      });
    },
    getTribeCheifProfit({ commit }, query) {
      api.getTribeCheifProfit(query).then(({ data }) => {
        if(data) {
          commit('setTableAble', false);
          commit('setData', {
            key: 'tribeCheifProfit',
            value: data
          });
          window.setTimeout(() => {
            commit('setTableAble', true);
          }, 1);
        }
      });
    },
    getTribeMemberProfit({ commit }, query) {
      api.getTribeMemberProfit(query).then(({ data }) => {
        if(data) {
          commit('setTableAble', false);
          commit('setData', {
            key: 'tribeMemberProfit',
            value: data.list
          });
          commit('setData', {
            key: 'tribeMemberProfitTotal',
            value: data.totalCount
          });
          window.setTimeout(() => {
            commit('setTableAble', true);
          }, 1);
        }
      });
    },
    getListingApplyData({ commit }, query) {
      api.getListingApplyData(query).then(({ data }) => {
        if(data) {
          commit('setTableAble', false);
          commit('setData', {
            key: 'listingApplyData',
            value: data.list
          });
          commit('setData', {
            key: 'listingApplyTotal',
            value: data.totalCount
          });
          window.setTimeout(() => {
            commit('setTableAble', true);
          }, 1);
        }
      });
    },
    getTradeVolumeData({ commit }, query) {
      api.getTradeVolumeData(query).then(({ data }) => {
        if(data) {
          commit('setTableAble', false);
          commit('setData', {
            key: 'tradeVolumeData',
            value: data
          });
          window.setTimeout(() => {
            commit('setTableAble', true);
          }, 1);
        }
      });
    },
    getTradeOrderData({ commit }, query) {
      api.getTradeOrderData(query).then(({ data }) => {
        if(data) {
          commit('setTableAble', false);
          commit('setData', {
            key: 'tradeOrderData',
            value: data.data
          });
          commit('setData', {
            key: 'tradeOrderTotal',
            value: data.total
          });
          window.setTimeout(() => {
            commit('setTableAble', true);
          }, 1);
        }
      });
    },
    getUnFinishTradeOrderData({ commit }, query) {
      api.getUnFinishTradeOrderData(query).then(({ data }) => {
        if(data) {
          commit('setTableAble', false);
          commit('setData', {
            key: 'unFinishOrderData',
            value: data
          });
          window.setTimeout(() => {
            commit('setTableAble', true);
          }, 1);
        }
      });
    },
    getTotalStakingPosition({ state, commit }, query) {
      api.getTotalStakingPosition(query).then(({ data }) => {
        if(data) {
          commit('setTableAble', false);
          commit('setData', {
            key: 'totalStakingPosition',
            value: data
          });
          console.log(state.totalStakingPosition);
          window.setTimeout(() => {
            commit('setTableAble', true);
          }, 1);
        }
      });
    },
    getUsetStakingPosition({ commit }, query) {
      api.getUsetStakingPosition(query).then(({ data }) => {
        if(data) {
          commit('setTableAble', false);
          commit('setData', {
            key: 'userStakingPosition',
            value: data
          });
          window.setTimeout(() => {
            commit('setTableAble', true);
          }, 1);
        }
      });
    },
    getUserLoginCount({ commit }, query) {
      api.getUserLoginCount(query).then(({ data }) => {
        if(data) {
          commit('setTableAble', false);
          commit('setData', {
            key: 'userLoginCount',
            value: data
          });
          window.setTimeout(() => {
            commit('setTableAble', true);
          }, 1);
        }
      });
    },
    getUserRegisterCount({ commit }, query) {
      api.getUserRegisterCount(query).then(({ data }) => {
        if(data) {
          commit('setTableAble', false);
          commit('setData', {
            key: 'userRegisterCount',
            value: data
          });
          window.setTimeout(() => {
            commit('setTableAble', true);
          }, 1);
        }
      });
    },
    getDepositWithdrawByTime({ commit }, query) {
      api.getDepositWithdrawByTime(query).then(({ data }) => {
        if(data) {
          let list = data || [];
          list.sort((a, b) => {
            return a.coinType > b.coinType ? 1 : -1;
          });
          commit('setTableAble', false);
          commit('setData', {
            key: 'depositWithdraw',
            value: list
          });
          window.setTimeout(() => {
            commit('setTableAble', true);
          }, 1);
        }
      });
    },
    getWithdrawFreeze({ commit }, query) {
      api.getWithdrawFreeze(query).then(({ data }) => {
        if(data) {
          commit('setTableAble', false);
          commit('setData', {
            key: 'withdrawFreeze',
            value: data
          });
          window.setTimeout(() => {
            commit('setTableAble', true);
          }, 1);
        }
      });
    },
    getCurrentRank({ commit }, query) {
      api.getCurrentRank(query).then(({ data }) => {
        if(data) {
          commit('setTableAble', false);
          commit('setData', {
            key: 'currentRank',
            value: data
          });
          window.setTimeout(() => {
            commit('setTableAble', true);
          }, 1);
        }
      });
    },
    getTxRecord({ commit }, query) {
      api.getTxRecord(query).then(({ data }) => {
        if(data) {
          commit('setTableAble', false);
          commit('setData', {
            key: 'txRecord',
            value: data.list
          });
          commit('setData', {
            key: 'txRecordTotal',
            value: data.totalCount
          });
          window.setTimeout(() => {
            commit('setTableAble', true);
          }, 1);
        }
      });
    },
    getTxStatistics({ commit }, query) {
      api.getTxStatistics(query).then(({ data }) => {
        if(data) {
          commit('setTableAble', false);
          commit('setData', {
            key: 'statisticList',
            value: data
          });
          window.setTimeout(() => {
            commit('setTableAble', true);
          }, 1);
        }
      });
    },
    getItxRecord({ commit }, query) {
        api.getItxRecord(query).then(({ data }) => {
            if(data) {
                commit('setTableAble', false);
                commit('setData', {
                    key: 'iTxRecord',
                    value: data.list
                });
                commit('setData', {
                    key: 'iTxRecordTotal',
                    value: data.totalCount
                });
                window.setTimeout(() => {
                    commit('setTableAble', true);
                }, 1);
            }
        });
    },
    getKycUserCount({commit},query) {
      api.queryUserCount(query).then(response => {
       commit('setKycUserCount',response.data);
      })
    },
    getDwSummary({ commit }, query) {
      api.getDwSummary(query).then(({ data }) => {
        if(data) {
          commit('setTableAble', false);
          commit('setData', {
            key: 'dwSummary',
            value: data.list
          });
          commit('setData', {
            key: 'dwSummaryTotal',
            value: data.totalCount
          });
          window.setTimeout(() => {
            commit('setTableAble', true);
          }, 1);
        }
      });
    },
    getReturnByStatus({ commit }, query) {
      api.getAllRecordByStatus(query).then(res => {
        commit('setReturnList', res.data.list)
        commit('setPagination', {page: query.page, size: query.size})
        commit('setReturnTotal', res.data.totalCount)
      })
    }
  }
};

appStore.registerModule('dataCenter', store);
